import { KNOWLEDGE_BASE } from 'src/constants/routes';
import css from './kb-general.module.scss';
import { Link } from 'react-router-dom';
import { Material } from 'src/types';
import { useGetMaterials } from '../data/queries';
import { Tabs } from '../selected-materials/selected-materials';
import { ReactComponent as EventLinkIcon } from 'src/assets/event-arrow.svg';

export default function KBGeneral({ type }: Readonly<{ type: Tabs }>) {
  const { data: materials = [] } = useGetMaterials({ type });

  if (materials.length === 0) return null;

  const modifyUrl = (url: string) => (url.includes('/articles/') ? url : `/articles/${url}`);

  return (
    <div className={css.kb}>
      <div className={css.content}>
        <div className={css.header}>
          <Link to={KNOWLEDGE_BASE.path}>
            <p>Вся база знань </p>
            <EventLinkIcon />
          </Link>
          <h3>База знань</h3>
        </div>
        <div className={css.modules}>
          {materials.map((m: Material) => (
            <Link key={m.id} to={KNOWLEDGE_BASE.path + modifyUrl(m.url)}>
              <p>{m.title}</p>
              <EventLinkIcon />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
